// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SwYUH","rootMobile":"styles_rootMobile__3YzsT"};